module.exports = __webpack_public_path__ + "static/img/icon-alt1.688d2b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report-imgs/icon-alt1.png
// module id = 1Hyf
// module chunks = 3